import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import ActionScreener from "@/modules/action-screens/services/ActionScreener";
import {AfterLeaguePromotionEvent} from "@/modules/competitions/events/AfterLeaguePromotionEvent";
import LeaguePromotionActionScreen from "@/modules/competitions/components/LeaguePromotionActionScreen.vue";
import {AfterCupPromotionEvent} from "@/modules/competitions/events/AfterCupPromotionEvent";

@injectable()
export class ActionScreensEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ActionScreener) private actionScreener: ActionScreener,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterLeaguePromotionEvent, callback: this.onAfterLeaguePromotionEvent},
      {event: AfterCupPromotionEvent, callback: this.onAfterCupPromotionEvent},
    ];
  }

  async onAfterCupPromotionEvent(event: AfterCupPromotionEvent): Promise<void> {
    if (event.team.isCurrent) {
      await this.actionScreener.show({
        component: LeaguePromotionActionScreen,
        props: event,
      });
    }
  }

  async onAfterLeaguePromotionEvent(event: AfterLeaguePromotionEvent): Promise<void> {
    if (event.team.isCurrent) {
      await this.actionScreener.show({
        component: LeaguePromotionActionScreen,
        props: event,
      });
    }
  }
}